import React from 'react'
import { Box, Typography, Chip } from '@mui/material'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import { DamageDetail } from './types'

interface DamageCardProps {
    damage: DamageDetail
}

const formatCurrency = (value: number | string) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(Number(value))
}

export const DamageCard: React.FC<DamageCardProps> = ({ damage }) => {
    return (
        <Box
            sx={{
                px: 2,
                py: 1.5,
                borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
                '&:last-child': { borderBottom: 'none' },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    mb: 0.5,
                }}
            >
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: '#fff' }}
                        >
                            {damage.description}
                        </Typography>
                        {damage.ai_generated && (
                            <Chip
                                icon={<SmartToyIcon sx={{ fontSize: 14 }} />}
                                label="AI"
                                size="small"
                                sx={{
                                    height: 20,
                                    backgroundColor: 'rgba(139, 92, 246, 0.15)',
                                    color: '#a78bfa',
                                    fontWeight: 600,
                                    fontSize: '0.65rem',
                                    '& .MuiChip-icon': { color: '#a78bfa' },
                                }}
                            />
                        )}
                    </Box>
                    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                        {damage.area_name}
                    </Typography>
                </Box>
                <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: '#ef4444', whiteSpace: 'nowrap', ml: 2 }}
                >
                    {formatCurrency(damage.total_cost)}
                </Typography>
            </Box>

            {(damage.attachments ?? []).length > 0 && (
                <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                    {damage.attachments.map((att) => (
                        <Box
                            key={att.id}
                            component="img"
                            src={att.url}
                            sx={{
                                width: 56,
                                height: 56,
                                borderRadius: 1,
                                objectFit: 'cover',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                            }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}
